export const SINGAPORE = {
  center: [103.819836, 1.352083],
  zoom: 11
}

export const layerIconGeojsonTemplate = {
  'id': 'eventpoints',
  'type': 'symbol',
  'source': {
    'type': 'geojson',
    'data': {
      'type': 'FeatureCollection',
      'features': []
    }
  },
  'layout': {
    'icon-image': 'event-icon',
    'icon-size': 0.05,
    'visibility': 'none',
    'icon-allow-overlap': true
  }
}
